(function () {
  document.addEventListener(
    'toggle',
    function (ev) {
      var el = ev.target;
      if (!(el instanceof HTMLDetailsElement)) return;
      if (!el.open) return;

      var group = el.closest('[data-accordion-exclusive]');
      if (!group) return;

      group.querySelectorAll('details').forEach(function (other) {
        if (other !== el && other.open) {
          other.open = false;
        }
      });
    },
    true
  );
})();

window.addEventListener("load", function () {
  document.querySelectorAll('product-page-embed').forEach(el => {
    const shadow = el.shadowRoot;
    if (shadow) {
      const style = document.createElement('style');
      style.textContent = `
        .loyalty-banner-row,
        .loyalty-banner-row-text {
          width: fit-content !important;
        }
      `;
      shadow.appendChild(style);
    }
  });
});


window.addEventListener("load", function () {
  // only run on mobile
  if (window.innerWidth > 768) return;

  const buyButtons = document.querySelector(".product-info__buy-buttons");
  if (!buyButtons) return;

  const sentinel = document.createElement("div");
  sentinel.style.height = "1px";
  buyButtons.parentNode.insertBefore(sentinel, buyButtons);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          buyButtons.classList.add("is-sticky");

          requestAnimationFrame(() => {
            buyButtons.classList.add("show");
          });
        } else {
          buyButtons.classList.remove("show");

          setTimeout(() => {
            buyButtons.classList.remove("is-sticky");
          }, 300);
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);
});

(function () {
  function refreshDescRoot(root) {
    var body = root.querySelector('[data-product-desc-body]');
    var btn = root.querySelector('[data-product-desc-toggle]');
    if (!body || !btn) return;
    var moreEl = btn.querySelector('[data-desc-label-more]');
    var lessEl = btn.querySelector('[data-desc-label-less]');
    if (!moreEl || !lessEl) return;

    if (root.classList.contains('is-expanded')) {
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      moreEl.hidden = true;
      lessEl.hidden = false;
      return;
    }

    btn.setAttribute('aria-expanded', 'false');
    moreEl.hidden = false;
    lessEl.hidden = true;

    var needs = body.scrollHeight > body.clientHeight + 2;
    btn.hidden = !needs;
  }

  function bindDescToggle(root) {
    var btn = root.querySelector('[data-product-desc-toggle]');
    if (!btn || btn.dataset.descBound === '1') return;
    btn.dataset.descBound = '1';
    btn.addEventListener('click', function () {
      root.classList.toggle('is-expanded');
      refreshDescRoot(root);
    });
  }

  function initProductDescToggles() {
    document.querySelectorAll('[data-product-desc]').forEach(function (root) {
      bindDescToggle(root);
      refreshDescRoot(root);
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initProductDescToggles, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDescToggles);
  } else {
    initProductDescToggles();
  }

  document.addEventListener('shopify:section:load', initProductDescToggles);
  window.addEventListener('resize', onResize);
})();

// window.onload = function () {
//   const switcher = document.querySelector("#transcySwitcherContainer");
//   const target = document.querySelector(".header__icon-list > div");

//   if (switcher && target) {
//     target.appendChild(switcher);
//   }
// };

window.addEventListener("load", function () {
  const target = document.querySelector(".header__icon-list > div");
  if (!target) return;

  const moveSwitcher = () => {
    const switcher = document.querySelector("#transcySwitcherContainer");
    if (!switcher) return;

    // ✅ check if already inside target
    if (target.contains(switcher)) return;

    target.appendChild(switcher);
  };

  // Run once in case it's already there
  moveSwitcher();

  // Observe DOM changes (for async loading)
  const observer = new MutationObserver(() => {
    moveSwitcher();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener('DOMContentLoaded', function() {
    var customButton = document.querySelector('.button--cc-custom');
    
    if(customButton){
      customButton.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent default action if needed
          var header = document.querySelector('.header__wrapper');
          var sectionStack = document.querySelector('.section-stack__main');

          var headerHeight = header.offsetHeight; 
          var sectionOffsetTop = sectionStack.getBoundingClientRect().top + window.scrollY; // Get the offset relative to the document

          window.scrollTo({
              top: sectionOffsetTop - headerHeight,
              behavior: 'smooth' // This will animate the scroll
          });

          console.log("Scrolling completed");
      });
    }
    
});


(function () {
  const ua = navigator.userAgent.toLowerCase();

  function addClass(name) {
    if (document.body) {
      document.body.classList.add(name);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        document.body.classList.add(name);
      });
    }
  }

  // OS
  if (ua.includes("windows")) {
    addClass("os-windows");
  } else if (ua.includes("mac os") || ua.includes("macintosh")) {
    addClass("os-mac");
  }

  // 🔥 Browser (Firefox)
  if (ua.includes("firefox")) {
    addClass("browser-firefox");
  }
})();


document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.hash;
    const target = document.querySelector(targetId);

    if (target) {
      e.preventDefault();

      // ✅ Set different offsets
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const offset = isMobile ? -100 : -100; // adjust values here

      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});

(function () {
  // Open the cart drawer after add-to-cart from product cards (including quick-buy/subscription flows).
  let shouldOpenDrawerAfterAdd = false;
  let cartCountBeforeSubmit = null;

  function getCartCount() {
    const el = document.querySelector('cart-count');
    if (!el) return null;
    const value = parseInt((el.textContent || '').replace(/[^\d]/g, ''), 10);
    return Number.isNaN(value) ? null : value;
  }

  function openCartDrawer() {
    const trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) {
      trigger.click();
    }
  }

  function isProductCardFlow(target) {
    if (!target) return false;

    if (target.closest('.product-card')) {
      return true;
    }

    const quickBuyDrawer = target.closest('quick-buy-drawer');
    if (!quickBuyDrawer) return false;

    const quickBuyId = quickBuyDrawer.getAttribute('id') || '';
    return quickBuyId.indexOf('quick-buy-') === 0 || quickBuyId.indexOf('quick-buy-info-') === 0;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const isProductForm = form.getAttribute('is') === 'product-form';
    if (!isProductForm) return;
    if (!isProductCardFlow(form)) return;

    shouldOpenDrawerAfterAdd = true;
    cartCountBeforeSubmit = getCartCount();
  });

  const cartCountEl = document.querySelector('cart-count');
  if (!cartCountEl) return;

  const observer = new MutationObserver(function () {
    if (!shouldOpenDrawerAfterAdd) return;

    const cartCountNow = getCartCount();
    if (cartCountNow === null) return;

    if (cartCountBeforeSubmit === null || cartCountNow > cartCountBeforeSubmit) {
      shouldOpenDrawerAfterAdd = false;
      cartCountBeforeSubmit = null;
      setTimeout(openCartDrawer, 120);
    }
  });

  observer.observe(cartCountEl, { childList: true, subtree: true, characterData: true });
})();

// (function () {
//   if (window.__dynamicPricingBound) return;
//   window.__dynamicPricingBound = true;

//   function formatMoneyFromCents(cents) {
//     var c = Math.round(Number(cents) || 0);

//     if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
//       var tv = window.themeVariables && window.themeVariables.settings;
//       var fmt =
//         tv && tv.currencyCodeEnabled ? tv.moneyWithCurrencyFormat : tv && tv.moneyFormat;

//       if (fmt) return window.Shopify.formatMoney(String(c), fmt);
//     }

//     var currency = 'GBP';

//     try {
//       var scripts = document.querySelectorAll('script[type="application/json"][id^="dynamic-product-pricing-"]');
//       if (scripts[0]) {
//         var d = JSON.parse(scripts[0].textContent || '{}');
//         if (d.currency) currency = d.currency;
//       }
//     } catch (e) {}

//     try {
//       return new Intl.NumberFormat(undefined, {
//         style: 'currency',
//         currency: currency,
//       }).format(c / 100);
//     } catch (e2) {
//       return (c / 100).toFixed(2);
//     }
//   }

//   function readSellingPlanValue(section, form) {
//     var v;

//     if (form && form.elements) {
//       for (var i = 0; i < form.elements.length; i++) {
//         var el = form.elements[i];
//         var n = el.name || '';
//         if (!n || (n !== 'selling_plan' && n.indexOf('selling_plan') !== 0)) continue;
//         if (el.type === 'radio' && !el.checked) continue;

//         v = String(el.value || '').trim();
//         if (v) return v;
//       }
//     }

//     if (!section) return '';

//     var checked = section.querySelector('input[name="selling_plan"]:checked');
//     if (checked) return String(checked.value || '').trim();

//     var sel = section.querySelector('select[name="selling_plan"]');
//     if (sel) return String(sel.value || '').trim();

//     var hid = section.querySelector('input[name="selling_plan"][type="hidden"]');
//     if (hid) return String(hid.value || '').trim();

//     return '';
//   }

//   function parseLoopWidgetUnitCents(section) {
//     var selected = section.querySelector('.loop-widget-purchase-option.loop-widget-purchase-option-selected');
//     if (!selected) {
//       var options = section.querySelectorAll('.loop-widget-purchase-option');
//       for (var oi = 0; oi < options.length; oi++) {
//         var option = options[oi];
//         var checkedInput = option.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
//         if (checkedInput || option.getAttribute('aria-checked') === 'true' || option.dataset.selected === 'true') {
//           selected = option;
//           break;
//         }
//       }
//     }
//     if (!selected || selected.classList.contains('loop-widget-purchase-option-onetime')) return null;

//     var priceEl = selected.querySelector('.loop-widget-purchase-option-price');
//     if (!priceEl) return null;

//     var text = (priceEl.textContent || '').replace(/\s+/g, ' ').trim();
//     var amounts = [];
//     var re = /[\p{Sc}]\s*([0-9]{1,3}(?:[,\s.][0-9]{3})*(?:[.,][0-9]{2})|[0-9]+(?:[.,][0-9]{2})?)/gu;
//     var m;

//     function normalizeAmount(raw) {
//       var cleaned = String(raw || '').replace(/\s/g, '');
//       var hasDot = cleaned.indexOf('.') !== -1;
//       var hasComma = cleaned.indexOf(',') !== -1;

//       if (hasDot && hasComma) {
//         if (cleaned.lastIndexOf('.') > cleaned.lastIndexOf(',')) {
//           cleaned = cleaned.replace(/,/g, '');
//         } else {
//           cleaned = cleaned.replace(/\./g, '').replace(',', '.');
//         }
//       } else if (hasComma && !hasDot) {
//         cleaned = cleaned.replace(',', '.');
//       } else {
//         cleaned = cleaned.replace(/,/g, '');
//       }

//       var parsed = parseFloat(cleaned);
//       return isNaN(parsed) ? null : Math.round(parsed * 100);
//     }

//     while ((m = re.exec(text)) !== null) {
//       var cents = normalizeAmount(m[1]);
//       if (cents !== null) amounts.push(cents);
//     }

//     if (!amounts.length) {
//       var fallbackRe = /([0-9]{1,3}(?:[,\s.][0-9]{3})*(?:[.,][0-9]{2,3}))/g;
//       while ((m = fallbackRe.exec(text)) !== null) {
//         var fallbackCents = normalizeAmount(m[1]);
//         if (fallbackCents !== null) amounts.push(fallbackCents);
//       }
//     }

//     if (!amounts.length) return null;

//     return {
//       sale: amounts[0],
//       compare: amounts.length > 1 ? amounts[1] : null,
//     };
//   }

//   function pickPlanPrice(plans, planId) {
//     if (!planId || !plans) return null;

//     if (plans[planId]) return plans[planId];

//     var tail = planId.split('/').pop();
//     if (plans[tail]) return plans[tail];

//     var keys = Object.keys(plans);
//     for (var i = 0; i < keys.length; i++) {
//       if (keys[i] === planId || keys[i].endsWith(tail)) return plans[keys[i]];
//     }

//     return null;
//   }

//   function setSalePriceVisibleText(el, value) {
//     if (!el) return;

//     // 🚀 prevent unnecessary DOM updates
//     if (el.textContent.trim() === value) return;

//     var sr = el.querySelector('.sr-only');

//     while (el.firstChild) {
//       el.removeChild(el.firstChild);
//     }

//     if (sr) el.appendChild(sr);

//     el.appendChild(document.createTextNode(value));
//   }

//   function syncDynamicProductPricing() {
//     var scripts = document.querySelectorAll('script[type="application/json"][id^="dynamic-product-pricing-"]');

//     for (var s = 0; s < scripts.length; s++) {
//       var data;

//       try {
//         data = JSON.parse(scripts[s].textContent || '{}');
//       } catch (e) {
//         continue;
//       }

//       if (!data.formId || !data.variants) continue;

//       var form = document.getElementById(data.formId);
//       if (!form) continue;

//       var section = form.closest('.shopify-section') || document;

//       var idInput = form.querySelector('input[name="id"]');
//       if (!idInput) continue;

//       var vid = String(idInput.value || '').trim();
//       var vdata = data.variants[vid];
//       if (!vdata) continue;

//       var qtyInput =
//         section.querySelector('input[name="quantity"][form="' + data.formId + '"]') ||
//         form.querySelector('input[name="quantity"]');

//       var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
//       if (!qty || qty < 1) qty = 1;

//       var planVal = readSellingPlanValue(section, form);

//       // ✅ state caching
//       var cacheKey = vid + "-" + qty + "-" + (planVal || "");
//       if (form.dataset.lastPriceState === cacheKey) continue;
//       form.dataset.lastPriceState = cacheKey;

//       var plan = pickPlanPrice(vdata.plans, planVal);

//       var unitSale = plan ? plan.price : vdata.price;
//       var unitCompare = plan && plan.compareAt ? plan.compareAt : vdata.compareAt || null;

//       var loopParsed = parseLoopWidgetUnitCents(section);
//       if (loopParsed) {
//         unitSale = loopParsed.sale;
//         if (loopParsed.compare != null) unitCompare = loopParsed.compare;
//       }

//       var totalSale = unitSale * qty;
//       var totalCompare = unitCompare ? unitCompare * qty : null;

//       var saleLabel = formatMoneyFromCents(totalSale);
//       var compareLabel = totalCompare ? formatMoneyFromCents(totalCompare) : '';

//       document.querySelectorAll('sale-price[form="' + data.formId + '"]').forEach(function (el) {
//         setSalePriceVisibleText(el, saleLabel);
//         el.classList.toggle('text-on-sale', unitCompare && unitCompare > unitSale);
//       });

//       document.querySelectorAll('compare-at-price[form="' + data.formId + '"]').forEach(function (el) {
//         if (totalCompare && unitCompare > unitSale) {
//           el.hidden = false;
//           setSalePriceVisibleText(el, compareLabel);
//         } else {
//           el.hidden = true;
//         }
//       });

//       var unitLabel = formatMoneyFromCents(unitSale);
//       document.querySelectorAll('[data-live-price-root][data-form-id="' + data.formId + '"]').forEach(function (root) {
//         var qtyEl = root.querySelector('[data-live-price-qty]');
//         var unitEl = root.querySelector('[data-live-price-unit]');
//         var totalEl = root.querySelector('[data-live-price-total]');
//         var compareRowEl = root.querySelector('[data-live-price-compare-row]');
//         var compareEl = root.querySelector('[data-live-price-compare]');

//         if (qtyEl) qtyEl.textContent = String(qty);
//         if (unitEl) unitEl.textContent = unitLabel;
//         if (totalEl) totalEl.textContent = saleLabel;

//         if (compareRowEl && compareEl) {
//           if (totalCompare && unitCompare > unitSale) {
//             compareRowEl.hidden = false;
//             compareEl.textContent = compareLabel;
//           } else {
//             compareRowEl.hidden = true;
//           }
//         }
//       });
//     }
//   }

//   let scheduled = false;

//   function scheduleDynamicPriceSync() {
//     if (scheduled) return;
//     scheduled = true;

//     requestAnimationFrame(() => {
//       syncDynamicProductPricing();
//       scheduled = false;
//     });
//   }

//   function bindDynamicProductPricing() {
//     document.addEventListener('change', scheduleDynamicPriceSync, true);

//     document.addEventListener('input', function (e) {
//       if (e.target && e.target.matches('input[name="quantity"]')) {
//         scheduleDynamicPriceSync();
//       }
//     }, true);

//     document.addEventListener('click', function (e) {
//       if (e.target && e.target.closest('.loop-widget-purchase-option')) {
//         scheduleDynamicPriceSync();
//         setTimeout(scheduleDynamicPriceSync, 80);
//       }
//     }, true);

//     document.addEventListener('change', function (e) {
//       if (!e.target) return;
//       if (e.target.closest('.loop-widget-purchase-option, .loop-widget-container') || String(e.target.name || '').indexOf('selling_plan') !== -1) {
//         scheduleDynamicPriceSync();
//         setTimeout(scheduleDynamicPriceSync, 80);
//       }
//     }, true);

//     // ✅ lighter observer
//     if (typeof MutationObserver !== 'undefined') {
//       var mo = new MutationObserver(scheduleDynamicPriceSync);
//       mo.observe(document.body, { childList: true, subtree: true });

//       var loopMo = new MutationObserver(function (mutations) {
//         for (var i = 0; i < mutations.length; i++) {
//           var target = mutations[i].target;
//           if (target && target.nodeType === 1 && target.closest && target.closest('.loop-widget-purchase-option, .loop-widget-container')) {
//             scheduleDynamicPriceSync();
//             setTimeout(scheduleDynamicPriceSync, 80);
//             break;
//           }
//         }
//       });
//       loopMo.observe(document.body, {
//         subtree: true,
//         childList: true,
//         characterData: true,
//         attributes: true,
//         attributeFilter: ['class', 'aria-checked', 'checked', 'value']
//       });
//     }

//     document.addEventListener('shopify:section:load', scheduleDynamicPriceSync);

//     scheduleDynamicPriceSync();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', bindDynamicProductPricing);
//   } else {
//     bindDynamicProductPricing();
//   }
// })();

(function () {
  if (window.__dynamicPricingBound) return;
  window.__dynamicPricingBound = true;

  function formatMoneyFromCents(cents, currency) {
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      var tv = window.themeVariables && window.themeVariables.settings;
      var fmt = tv && tv.currencyCodeEnabled ? tv.moneyWithCurrencyFormat : tv && tv.moneyFormat;
      if (fmt) return window.Shopify.formatMoney(String(Math.round(cents)), fmt);
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function setTextIfChanged(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
  }

  function updateLivePriceBlock(formId, variant, qty) {
    if (!formId || !variant) return;
    qty = Math.max(1, parseInt(qty) || 1);

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var unitSale = variant.price;
    var unitCompare = (variant.compare_at_price > variant.price) ? variant.compare_at_price : null;
    var onSale = !!unitCompare;
    var totalSale = unitSale * qty;
    var totalCompare = unitCompare ? unitCompare * qty : null;

    var totalLabel = formatMoneyFromCents(totalSale, currency);
    var saleLabel  = formatMoneyFromCents(unitSale, currency);
    var totalCompareLabel = totalCompare ? formatMoneyFromCents(totalCompare, currency) : '';

    document.querySelectorAll('[data-live-price-root][data-form-id="' + formId + '"]').forEach(function (root) {
      setTextIfChanged(root.querySelector('[data-live-price-total]'), totalLabel);
      setTextIfChanged(root.querySelector('[data-live-price-unit]'), saleLabel);
      var qtyEl = root.querySelector('[data-live-price-qty]');
      if (qtyEl && qtyEl.textContent !== String(qty)) qtyEl.textContent = String(qty);

      var compareRow = root.querySelector('[data-live-price-compare-row]');
      var compareEl  = root.querySelector('[data-live-price-compare]');
      if (compareRow) {
        if (onSale && totalCompareLabel) {
          if (compareRow.hidden) compareRow.hidden = false;
          setTextIfChanged(compareEl, totalCompareLabel);
        } else {
          if (!compareRow.hidden) compareRow.hidden = true;
        }
      }
    });
  }

  function getVariantFromJson(formId, vid) {
    var scripts = document.querySelectorAll('script[type="application/json"][id^="dynamic-product-pricing-"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent || '{}');
        if (data.formId === formId && data.variants && data.variants[vid]) {
          var v = data.variants[vid];
          return { price: v.price, compare_at_price: v.compareAt || 0 };
        }
      } catch (e) {}
    }
    return null;
  }

  // Variant change: redirect to the variant URL so the full page re-renders with correct prices
  // (Loop widget, main price, etc. all come from server-side Liquid on the reloaded page).
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.location.href = url.toString();
  });

  // Quantity change: only fires from real user input on quantity fields
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'quantity') return;
    var form = input.closest('form[action*="/cart/add"]');
    if (!form) return;
    var formId = form.getAttribute('id');
    if (!formId) return;
    var vidInput = form.querySelector('[name="id"]');
    var vid = vidInput && vidInput.value;
    if (!vid) return;
    var variant = getVariantFromJson(formId, vid);
    if (variant) updateLivePriceBlock(formId, variant, parseInt(input.value) || 1);
  }, true);

})();

(function () {
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-line-qty-delta]');
    if (!btn || !btn.closest('cart-drawer')) return;

    var delta = parseInt(btn.getAttribute('data-line-qty-delta'), 10);
    if (!delta) return;

    ev.preventDefault();

    var wrap = btn.closest('line-item-quantity');
    if (!wrap) return;

    var input = wrap.querySelector('input.quantity-input, input[is="quantity-input"]');
    if (!input) return;

    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : null;
    if (maxAttr && Number.isNaN(max)) max = null;

    var raw = String(input.value || '').replace(/[^\d]/g, '');
    var v = parseInt(raw, 10);
    if (Number.isNaN(v)) v = 1;

    v += delta;
    if (v < 1) v = 1;
    if (max != null && !Number.isNaN(max) && v > max) v = max;

    var prev = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
    if (!Number.isNaN(prev) && v === prev) return;

    input.value = String(v);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.id !== 'cart-drawer-discount-form') return;

    ev.preventDefault();

    var input = form.querySelector('input[name="discount"]');
    var code = input && input.value ? String(input.value).trim() : '';
    if (!code) return;

    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    var path = window.location.pathname + window.location.search || '/';
    var redirect = encodeURIComponent(path);

    window.location.assign(
      root + 'discount/' + encodeURIComponent(code) + '?redirect=' + redirect
    );
  });
})();

(function () {
  if (window.__loopFixBound) return;
  window.__loopFixBound = true;

  function triggerLoopInit(container) {
    if (!container) return;

    // 🔥 Trigger Shopify section load (Loop listens to this)
    const event = new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId: container.dataset?.sectionId || 'quick-add' }
    });

    container.dispatchEvent(event);

    // 🔥 Extra fallback (some apps listen globally)
    document.dispatchEvent(new Event('shopify:section:load'));

    // 🔥 Give time for DOM → then force reflow
    setTimeout(() => {
      container.querySelectorAll('.loop-widget-container').forEach(el => {
        el.style.display = 'none';
        el.offsetHeight; // force reflow
        el.style.display = '';
      });
    }, 200);
  }

  // 🔥 Detect Quick Add / Drawer content
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        // detect drawer / quick add
        if (
          node.matches?.('.drawer, .modal, .quick-add') ||
          node.querySelector?.('.drawer, .modal, .quick-add')
        ) {
          setTimeout(() => {
            triggerLoopInit(node);
          }, 300);
        }

        // detect loop container directly
        if (
          node.querySelector?.('.loop-widget-container') ||
          node.querySelector?.('.loop-widget-skeleton-container')
        ) {
          setTimeout(() => {
            triggerLoopInit(node);
          }, 300);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


(function () {
  var DEBOUNCE_MS = 350;
  var MIN_CHARS = 2;
  var MAX_PAGES = 10;

  // Patch history.pushState once so facet-form filter changes dispatch a custom event.
  // The facet-form always calls pushState after its DOM updates are complete.
  if (!window._bioSearchPushStatePatched) {
    window._bioSearchPushStatePatched = true;
    var _origPushState = history.pushState;
    history.pushState = function () {
      _origPushState.apply(this, arguments);
      window.dispatchEvent(new CustomEvent('facet:urlchange'));
    };
    window.addEventListener('popstate', function () {
      window.dispatchEvent(new CustomEvent('facet:urlchange'));
    });
  }

  function debounce(fn, delay) {
    var t;
    return function () {
      clearTimeout(t);
      var self = this, args = arguments;
      t = setTimeout(function () { fn.apply(self, args); }, delay);
    };
  }

  function getActiveFilterParams() {
    var excluded = { q: 1, page: 1, section_id: 1, type: 1 };
    var params = new URLSearchParams(window.location.search);
    var parts = [];
    params.forEach(function (value, key) {
      if (!excluded[key]) parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return parts.join('&');
  }

  function fetchSearchPage(query, page, extraParams) {
    var url = '/search?q=' + encodeURIComponent(query)
      + '&type=product'
      + '&page=' + page;
    if (extraParams) url += '&' + extraParams;

    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('product-list.product-list');
        return {
          cards: list ? list.innerHTML : '',
          hasNext: !!doc.querySelector('a[rel="next"]'),
          empty: !list || list.children.length === 0
        };
      });
  }

  function fetchAllPages(query, extraParams) {
    return new Promise(function (resolve) {
      var combined = '';
      var page = 1;

      function next() {
        if (page > MAX_PAGES) { resolve(combined); return; }
        fetchSearchPage(query, page, extraParams)
          .then(function (result) {
            if (result.empty) { resolve(combined); return; }
            combined += result.cards;
            if (result.hasNext) { page++; next(); }
            else { resolve(combined); }
          })
          .catch(function () { resolve(combined); });
      }

      next();
    });
  }

  function getCollectionHandles(handle) {
    return fetch('/collections/' + handle + '/products.json?fields=handle&limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return new Set((data.products || []).map(function (p) { return p.handle; }));
      });
  }

  function getFilteredCollectionHandles(handle, filterParams) {
    return new Promise(function (resolve) {
      var handles = new Set();
      var page = 1;
      function next() {
        if (page > MAX_PAGES) { resolve(handles); return; }
        fetch('/collections/' + handle + '?page=' + page + '&' + filterParams)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('product-card[handle]');
            if (cards.length === 0) { resolve(handles); return; }
            cards.forEach(function (c) { handles.add(c.getAttribute('handle')); });
            if (doc.querySelector('a[rel="next"]')) { page++; next(); }
            else { resolve(handles); }
          })
          .catch(function () { resolve(handles); });
      }
      next();
    });
  }

  function filterByCollection(cardsHTML, allowedHandles) {
    var tmp = document.createElement('div');
    tmp.innerHTML = cardsHTML;
    Array.from(tmp.querySelectorAll('product-card[handle]')).forEach(function (card) {
      if (!allowedHandles.has(card.getAttribute('handle'))) card.remove();
    });
    return tmp.innerHTML;
  }

  function initCollectionSearch() {
    var collectionResults = document.querySelector('.collection__results');
    if (!collectionResults) return;

    var productList = collectionResults.querySelector('product-list.product-list');
    if (!productList) return;

    var searchForm = document.querySelector('.facet-collection-search');
    var scope = searchForm ? (searchForm.dataset.scope || '') : '';
    var scopeIsAll = !scope || scope === 'all';

    var pagination = document.querySelector('.collection__pagination');
    var originalHTML = productList.innerHTML;
    var activeQuery = '';
    var handlesCache = null;
    var facetUrlTimer;

    function getScopedHandles() {
      if (scopeIsAll) return Promise.resolve(null);
      if (handlesCache) return Promise.resolve(handlesCache);
      return getCollectionHandles(scope).then(function (set) {
        handlesCache = set;
        return set;
      });
    }

    function restoreOriginal() {
      // Re-query in case the element was replaced by facet-form
      var current = collectionResults.querySelector('product-list.product-list');
      if (current) {
        productList = current;
        productList.innerHTML = originalHTML;
      }
      if (pagination) pagination.hidden = false;
      activeQuery = '';
    }

    function doSearch(query) {
      query = query.replace(/[^a-zA-Z0-9\s\-]/g, '').trim();
      if (!query) { restoreOriginal(); return; }
      if (query === activeQuery) return;
      activeQuery = query;

      if (query.length < MIN_CHARS) {
        restoreOriginal();
        return;
      }

      // Re-query in case facet-form replaced the element since last render
      var fresh = collectionResults.querySelector('product-list.product-list');
      if (fresh) productList = fresh;

      if (pagination) pagination.hidden = true;
      productList.innerHTML = '<div class="collection-live-search-state" style="grid-column:1/-1;text-align:center;padding:60px 20px;opacity:.5;">Searching…</div>';

      var activeParams = getActiveFilterParams();
      var searchFetch, handlesPromise;

      if (!scopeIsAll && activeParams) {
        // Specific collection with active filters:
        // Search without filter params (avoids S&D filter param issues on /search endpoint),
        // then intersect with handles fetched from the filtered collection pages — which
        // definitively reflect the active S&D filter selections.
        searchFetch = fetchAllPages(query, '');
        handlesPromise = getFilteredCollectionHandles(scope, activeParams);
      } else {
        // All-products collection or no filters active:
        // Pass any active params to the search fetch and use standard collection scoping.
        searchFetch = fetchAllPages(query, activeParams);
        handlesPromise = getScopedHandles();
      }

      Promise.all([searchFetch, handlesPromise])
        .then(function (results) {
          if (query !== activeQuery) return;
          // Re-query again — async time has passed, element may have been replaced
          var current = collectionResults.querySelector('product-list.product-list');
          if (current) productList = current;
          var cardsHTML = results[0];
          var allowedHandles = results[1];
          var finalHTML = allowedHandles ? filterByCollection(cardsHTML, allowedHandles) : cardsHTML;
          if (!finalHTML.trim()) {
            productList.innerHTML = '<div class="collection-live-search-state" style="grid-column:1/-1;text-align:center;padding:60px 20px;">'
              + '<p>No products found for “<strong>' + query + '</strong>"</p></div>';
          } else {
            productList.innerHTML = finalHTML;
          }
        });
    }

    // facet-form calls history.pushState after its DOM updates are done.
    // Re-capture state and re-run search when that happens.
    window.addEventListener('facet:urlchange', function () {
      clearTimeout(facetUrlTimer);
      // Cancel any in-flight search so it won't overwrite the facet-form's fresh content
      activeQuery = '__reset__';
      facetUrlTimer = setTimeout(function () {
        var newList = collectionResults.querySelector('product-list.product-list');
        if (newList) {
          productList = newList;
          originalHTML = newList.innerHTML;
        }
        activeQuery = '';
        var input = document.querySelector('.facet-collection-search__input');
        var q = input ? input.value.trim() : '';
        if (q.length >= MIN_CHARS) doSearch(q);
      }, 150);
    });

    document.addEventListener('input', function (ev) {
      var input = ev.target;
      if (!input.classList.contains('facet-collection-search__input')) return;
      // Restore product list as soon as the field is cleared
      if (!input.value.trim()) restoreOriginal();
    });

    document.addEventListener('keydown', function (ev) {
      if (!ev.target.classList.contains('facet-collection-search__input')) return;
      if (ev.key === 'Enter') {
        ev.preventDefault();
        var q = ev.target.value.trim();
        if (!q) return;
        // Stay on the same collection page — add ?q= so the keyword survives the reload
        // and is pre-filled via the Liquid value attribute on the input.
        var url = new URL(window.location.href);
        url.searchParams.set('q', q);
        window.location.assign(url.toString());
      } else if (ev.key === 'Escape') {
        document.querySelectorAll('.facet-collection-search__input').forEach(function (el) { el.value = ''; });
        restoreOriginal();
      }
    });

    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (target.classList.contains('facet-collection-search__btn') || target.closest('.facet-collection-search__btn')) {
        var form = target.closest('.facet-collection-search');
        var input = form && form.querySelector('.facet-collection-search__input');
        var q = input ? input.value.trim() : '';
        if (q) {
          var url = new URL(window.location.href);
          url.searchParams.set('q', q);
          window.location.assign(url.toString());
        }
      } else if (target.classList.contains('facet-collection-search__clear')) {
        document.querySelectorAll('.facet-collection-search__input').forEach(function (el) { el.value = ''; });
        restoreOriginal();
      }
    });

    // On page load, if ?q= is in the URL (from a previous Enter), auto-run the search.
    var initQuery = new URLSearchParams(window.location.search).get('q') || '';
    initQuery = initQuery.replace(/[^a-zA-Z0-9\s\-]/g, '').trim();
    if (initQuery.length >= MIN_CHARS) {
      document.querySelectorAll('.facet-collection-search__input').forEach(function (el) {
        el.value = initQuery;
      });
      doSearch(initQuery);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSearch);
  } else {
    initCollectionSearch();
  }
})();
